import { fuseAdoptionConstants } from "../_redux-constants";
import { fuseAdoptionService } from "../../_services";

function getFuseAdoptionLoad() {
  return { type: fuseAdoptionConstants.FUSE_ADOPTION_LOADING };
}

function fuseAdoptionSuccess(data) {
  return { type: fuseAdoptionConstants.FUSE_ADOPTION_SUCCESS, data };
}

function FuseAdoptionFailure(error) {
  return { type: fuseAdoptionConstants.FUSE_ADOPTION_FAILURE, error };
}

function getFuseAdoptionData({ version, fuseDevice }) {
  return (dispatch) => {
    dispatch(getFuseAdoptionLoad());
    return new Promise((resolve, reject) => {
      fuseAdoptionService.getFuseAdoptionData({ version, fuseDevice }).then(
        (data) => {
          dispatch(fuseAdoptionSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(FuseAdoptionFailure(error?.toString()));
          reject(error);
        }
      );
    });
  };
}

export const fuseAdoptionActions = {
  getFuseAdoptionData,
};
